import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { mandaModello, nomeDaScrivere, testoRipresa } from "@/lib/modelli";

/**
 * «Manda un modello» a finestra chiusa: l'unico messaggio che WhatsApp lascia mandare dopo 24 ore. Il testo
 * è quello approvato da Meta, non si cambia; si sceglie solo il nome. Parte dal numero dello showroom, come
 * gli automatici: fra le 21 e le 9 aspetta le 9.
 */
export default function ModelloDialog({ open, onOpenChange, waId, nomeContatto, mittente, onFatto }) {
  const [nome, setNome] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (open) setNome(nomeDaScrivere(nomeContatto));
  }, [open, nomeContatto]);

  const pulito = nome.replace(/\s+/g, " ").trim();
  const manda = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await mandaModello(waId, pulito);
      if (r.stato === "saltato" || r.stato === "errore") toast.error(`Non è partito: ${r.motivo_salto || "errore di invio"}`);
      else toast.success(r.silenzio ? "Il messaggio parte domattina alle 9" : "Messaggio in invio");
      onOpenChange(false);
      onFatto();
    } catch (err) {
      toast.error(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="modello-dialogo">
        <form onSubmit={manda} className="grid gap-card">
          <DialogHeader>
            <DialogTitle>Riprendi la conversazione</DialogTitle>
            <DialogDescription>
              È un messaggio già approvato da WhatsApp, l'unico che puoi mandare dopo 24 ore. Quando la persona risponde, la finestra si riapre e scrivi come sempre.
            </DialogDescription>
          </DialogHeader>
          <div className="grid gap-inside">
            <Label htmlFor="modello-nome">Nome di chi lo riceve</Label>
            <Input id="modello-nome" value={nome} onChange={(e) => setNome(e.target.value)} maxLength={40} placeholder="Marta" required data-testid="modello-nome" />
          </div>
          <div className="grid gap-micro rounded-md bg-surface-2 px-group py-group text-body text-ink" data-testid="modello-anteprima">
            <span className="text-caption font-bold text-ink-2">Così lo legge</span>
            <p>{testoRipresa(pulito || "…", mittente || "…")}</p>
          </div>
          <p className="text-small text-ink-2">Di notte i messaggi automatici non partono: se lo mandi dopo le 21, parte alle 9.</p>
          <DialogFooter className="gap-inside">
            <Button type="button" variant="secondary" onClick={() => onOpenChange(false)}>
              Annulla
            </Button>
            <Button type="submit" disabled={busy || !pulito} data-testid="modello-manda">
              {busy ? "Mando…" : "Manda questo messaggio"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
